<template>
  <n-config-provider :theme="naiveTheme">
    <n-message-provider>
      <MessageBootstrap />
      <div
        :id="isFullscreen ? undefined : 'app-canvas'"
        class="bg-background text-text-main"
        :class="isFullscreen ? 'fullscreen-root' : 'app-canvas'"
        :style="isFullscreen ? undefined : canvasStyle"
      >
        <router-view />
        <GlobalModals />
      </div>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { NConfigProvider, NMessageProvider, darkTheme } from 'naive-ui'
import { useTheme } from '@/composables/useTheme'
import GlobalModals from '@/components/common/GlobalModals.vue'
import MessageBootstrap from '@/components/common/MessageBootstrap.vue'
import { getScreenScale } from '@/composables/useScreenScale'

// Initialize theme system - this will apply the theme immediately
const { isDark } = useTheme()

// Configure Naive UI theme based on current theme
const naiveTheme = computed(() => {
  return isDark.value ? darkTheme : null
})

// 全局等比缩放：画布 1920×1080 用 transform: scale 缩放，保持 body 级弹层定位正确
const route = useRoute()

// 认证页等独立页面脱离 1920×1080 缩放画布，用真实视口渲染，避免小屏设备上表单被缩小到不可见
const isFullscreen = computed(() => !!route.meta.fullscreen)

const scale = ref(getScreenScale())
const onResize = () => { scale.value = getScreenScale() }
onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))
const canvasStyle = computed(() => ({
  transform: `scale(${scale.value})`
}))
</script>

<style>
/* Global styles are imported in main.ts */
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

#app {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-canvas {
  width: 1600px;
  height: 900px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  transform-origin: center center;
}

/* 认证页等独立页面：脱离画布缩放，撑满视口、可滚动，适配任意分辨率。
   position:fixed 脱离 #app 的 flex 居中布局，避免被压缩成内容宽度 */
.fullscreen-root {
  position: fixed;
  inset: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
